import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Color } from '@swimlane/ngx-charts';
import { ObservableInput } from 'ngx-observable-input';
import { interval, Observable, combineLatest } from 'rxjs';
import { map, startWith, distinctUntilChanged  } from 'rxjs/operators';
import { Single } from '../../../interfaces/single.interface';
import { gaugeThresholdSettings } from '../../widgets/fuel-gauge-chart-widget/fuel-gauge-chart-widget.component';

@Component({
  selector: 'fuel-gauge-new',
  templateUrl: './fuel-gauge-new.component.html',
  styleUrls: ['./fuel-gauge-new.component.css']
})
export class FuelGaugeNewComponent implements OnInit {

  @Input()
  options: FuelGaugeChartOptions = null;

  @ObservableInput()
  @Input("results")
  results$: Observable<Single[]>;
  _result: Observable<Single>;


  @ObservableInput()
  @Input("min")
  min$: Observable<number>;
  _min: Observable<number>;

  @ObservableInput()
  @Input("max")
  max$: Observable<number>;
  _max: Observable<number>;

  @Output()
  select: EventEmitter<any> = new EventEmitter();


  gaugeType = "semi";
  gaugeLabel = "";
  gaugeAppendText = "%";
  thickness = "20";
  animationDuration = "2000";
  cap = 'butt';

  thresholds_Default = {
    '0': { color: 'red' }, //if background colours are ever needed back: bgOpacity: 0.35
    '40': { color: 'orange' },
    '75': { color: 'green' }
  };



  markerConfig = {
    "0": { color: '#ff0000', size: 8, label: '0', type: 'line' },
    "10": { color: '#555', size: 8, label: '10', type: 'line' },
    "20": { color: '#555', size: 8, label: '20', type: 'line' },
    "30": { color: '#555', size: 8, label: '30', type: 'line' },
    "40": { color: '#555', size: 8, label: '40', type: 'line' },
    "50": { color: '#555', size: 8, label: '50', type: 'line' },
    "60": { color: '#555', size: 8, label: '60', type: 'line' },
    "70": { color: '#555', size: 8, label: '70', type: 'line' },
    "80": { color: '#555', size: 8, label: '80', type: 'line' },
    "90": { color: '#555', size: 8, label: '90', type: 'line' },
    "100": { color: '#555', size: 8, label: '100', type: 'line' },
  };


  parentWidth: Observable<number> = interval(10).pipe(
    map(() => this.parentElement.nativeElement.offsetWidth),
    distinctUntilChanged()
  );

  parentHeight: Observable<number> = interval(10).pipe(
    map(() => {
      return this.parentElement.nativeElement.offsetHeight;
    }),
    distinctUntilChanged()
  );

  size: Observable<number> = combineLatest(this.parentWidth, this.parentHeight).pipe(
    map(([parentWidth, parentHeight]) => parentWidth < parentHeight ? parentWidth : parentHeight ),
  );

  constructor(private parentElement: ElementRef){


  }

  ngOnInit(): void {
    this._result = this.results$.pipe(
      map(singles => {
        return (singles ?? [])[0];
      })
    )

    this._min = this.min$.pipe(startWith(null));
    this._max = this.max$.pipe(startWith(null));

   
  }


  onClick(data): void {
    this.select.emit(data);
  }

}

export interface FuelGaugeChartOptions {
  thresholds: any,
  gaugeType: string,
  gaugeLabel: string,
  gaugeAppendText: string,
  thickness: number,
  cap: string;
  animationDuration: number,

  colourScheme: string | Color
}
